import type { LoginSession } from '@mathflat/domain/Auth'
import { jwtTokenService } from '@mathflat/shared/@modules/auth/jwtTokenService'

type AuthState = 'authenticated' | 'anonymous'

type AuthStatePayload = {
  state: AuthState
  academyId?: LoginSession['academyId']
  teacherId?: LoginSession['userId']
  /** x-auth-token (레거시) */
  token?: string
  /** Bearer */
  accessToken?: string
}

const send = (payload: AuthStatePayload) => {
  window.bridge?.send('auth-state', payload)
}

/**
 * 로그인이 확정된 뒤 앱에 인증 상태를 넘긴다.
 *
 * 식별자는 인자로 받는다 — 이 시점의 스토리지 키가 v1(`TEACHER_ID`)·v2(`teacher-id`)로 갈려 있어
 * 어느 쪽을 읽느냐에 따라 값이 달라질 수 있고, 로그인 응답이 이미 정답을 갖고 있다.
 * 토큰은 반대로 jwtTokenService 에서 읽는다 — 저장 위치(local·session)와 레거시 마이그레이션을
 * 그쪽이 알고 있어 호출부가 다시 판단할 이유가 없다.
 */
export const notifyAppAuthenticated = ({
  academyId,
  teacherId,
}: {
  academyId: LoginSession['academyId']
  teacherId: LoginSession['userId']
}) => {
  const token = jwtTokenService.getLegacyToken() ?? undefined
  const accessToken = jwtTokenService.getAccessToken() ?? undefined

  // 앱은 token·accessToken 중 최소 하나로 인증한다. 둘 다 없으면 앱이 쓸 수 있는 게 없어 보내지 않는다.
  if (!token && !accessToken) return

  send({ state: 'authenticated', academyId, teacherId, token, accessToken })
}

/** 로그아웃이 확정된 뒤 앱에 비인증 상태를 넘긴다. */
export const notifyAppAnonymous = () => {
  send({ state: 'anonymous' })
}
